
import { CommunityModel } from './CommunityModel';
import { CustomerModel } from './CustomerModel';
import { Country } from './Enums';
import { PackageBasicModel } from './PackageModel';
import { ScratchModel } from './ScratchModel';
import { TransactionPackageModel } from './TransactionModel';

export class PackageScratchCustomerModel { 

    constructor(init?: Partial<PackageScratchCustomerModel>) {
        if (init) {
            if (init.transactionPackage) {
                init.transactionPackage = new TransactionPackageModel(init.transactionPackage);
            }
            if (typeof init.scratch) {
                init.scratch = new ScratchModel(init.scratch);
            }
            if (init.package) {
                init.package = new PackageBasicModel(init.package);
            }
            if (init.customer) {
                init.customer = new CustomerModel(init.customer);
            }
            if (init.customerOwner) {
                init.customerOwner = new CustomerModel(init.customerOwner);
            }

            if (typeof init.createdAt === 'string') {
                this.createdAt = new Date(init.createdAt);
            }

            if (init.updatedAt && typeof init.updatedAt === 'string') {
                this.updatedAt = new Date(init.updatedAt);
            }

            if (init.deletedAt && typeof init.deletedAt === 'string') {
                this.deletedAt = new Date(init.deletedAt);
            }

            if (init.lastReceivedAt && typeof init.lastReceivedAt === 'string') {
                this.lastReceivedAt = new Date(init.lastReceivedAt);
            }

            if (init.activatedAt && typeof init.activatedAt === 'string') {
                this.activatedAt = new Date(init.activatedAt);
            }

            Object.assign(this, init);
        }
    }

    id: number;

    transactionPackageId: number;
    packageId: number;
    scratchId: number;
    customerId: number;
    customerOwnerId: number;

    country = Country.CR;
    community: CommunityModel;
    
    lastReceivedAt?: Date;
    activatedAt?: Date;

    createdAt: Date;
    updatedAt?: Date;
    deletedAt?: Date;

    transactionPackage: TransactionPackageModel;
    package: PackageBasicModel;
    scratch: ScratchModel;
    customer: CustomerModel;
    customerOwner: CustomerModel;

    get validPackage(): boolean {

        let result = true;

        // Valida que si la transferencia tiene asociado un paquete y no esta activa no muestre los beneficios
        if (this.transactionPackage && this.transactionPackage.activatedAt == null){
            result = false;
        }

        return result;
    }
}